import axiosApiInstance from '../../interceptors/axiosApiInstance';
import {BASE_URL, NETWORK_ERROR} from '../config';
import {setServiceMessage} from "../../helpers/helper";

const OperationService = {
    /**
     * @Description Service of Getting Operation Detail
     * @Param       startDate=''
     * @Param       endDate=''
     * @Param       operationType=''
     * @Returns     response or error
     * @Author      ibrahim AKIN
     */
    getOperation: async function (startDate = '', endDate = '', operationType = 'automation') {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/operation?operationType=${operationType}&startDate=${startDate}&endDate=${endDate}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description Service of Getting Operations Count
     * @Param       startDate=''
     * @Param       endDate=''
     * @Param       operationType=''
     * @Returns     response or error
     * @Author      ibrahim AKIN
     */
    getOperationCount: async function (startDate = '', endDate = '', operationType = 'automation') {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/operation/count?operationType=${operationType}&startDate=${startDate}&endDate=${endDate}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description Service of Getting Average Time Elapse
     * @Param       startDate=''
     * @Param       endDate=''
     * @Param       operationType=''
     * @Returns     response or error
     * @Author      ibrahim AKIN
     */
    getOperationAvgTime: async function (startDate = '', endDate = '', operationType = 'automation') {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/operation/avg/time-elapsed?operationType=${operationType}&startDate=${startDate}&endDate=${endDate}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description Service of Getting Total Time Elapse
     * @Param       startDate=''
     * @Param       endDate=''
     * @Returns     response or error
     * @Author      ibrahim AKIN
     */
    getOperationTotalTime: async function (startDate = '', endDate = '') {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/operation/total/time-elapsed?startDate=${startDate}&endDate=${endDate}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getQuePoolOperations: async function (status, qpool_id, startIndex, itemsPerPage, searchValue) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/operation/filter/queue/pool`, {
                params: {
                    status,
                    qpool_id,
                    startIndex,
                    itemsPerPage,
                    searchValue
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getAutomOperations: async function (status, autom_id, startIndex, itemsPerPage, searchValue) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/operation/filter/autom`, {
                params: {
                    status,
                    autom_id,
                    startIndex,
                    itemsPerPage,
                    searchValue
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getMonitoringOperations: async function (status, startIndex, itemsPerPage, searchValue) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/operation/filter/status`, {
                params: {
                    status,
                    startIndex,
                    itemsPerPage,
                    searchValue
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description Service of Getting Operation Percentage
     * @Param       startDate=''
     * @Param       endDate=''
     * @Param       operationType=''
     * @Returns     response or error
     * @Author      ibrahim AKIN
     */
    getOperationPercentage: async function (startDate = '', endDate = '', operationType = 'automation') {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/operation/percentage?operationType=${operationType}&startDate=${startDate}&endDate=${endDate}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
    ,
    /**
     * @Description Service of Top Count Bots According To Running
     * @Param       startDate=''
     * @Param       endDate=''
     * @Param       top=4
     * @Param       operationType=''
     * @Returns     response or error
     * @Author      ibrahim AKIN
     */
    getOperationRank: async function (startDate = '', endDate = '', operationType = 'automation', top = 4) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/operation/working/rank?operationType=${operationType}&startDate=${startDate}&endDate=${endDate}&top=${top}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description Service of retrying operation
     * @Param       id
     * @Returns     response or error
     * @Author      Onur DOGUCU
     */
    retryOperation: async function (id) {
        try {
            const response = await axiosApiInstance.post(await BASE_URL + '/operation/retry', { operation_id: id });
            return response.data;
        } catch (error) {
            if (error.response) {
                return setServiceMessage(error.response.data, '');
            } else {
                return NETWORK_ERROR;
            }
        }
    },
    /**
     * @Description Service of getting operation trigger
     * @Param       id
     * @Returns     response or error
     * @Author      Onur DOGUCU
     */
    getOperationTrigger: async function (id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/operation/trigger${id}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    /**
     * @Description Service of getting operation trigger data
     * @Param       id
     * @Returns     response or error
     * @Author      Onur DOGUCU
     */
    getOperationTriggerData: async function (id) {
        try {
            const response = await axiosApiInstance.get(await BASE_URL + `/operation/trigger/data${id}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
};
export default OperationService;
